import { render, staticRenderFns } from "./pbbg.vue?vue&type=template&id=231a01da&scoped=true&"
import script from "./pbbg.vue?vue&type=script&lang=js&"
export * from "./pbbg.vue?vue&type=script&lang=js&"
import style0 from "./pbbg.vue?vue&type=style&index=0&id=231a01da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a01da",
  null
  
)

export default component.exports